<template>
	<b-form-group class="mb-0 slider-form-group">
		<template #label>
			<div class="d-flex justify-content-between align-items-baseline">
				<span>{{ label }}</span>
				<slot />
			</div>
		</template>
		<b-form-input
			type="range"
			:min="min"
			:max="max"
			:step="step"
			:value="value"
			@input="$emit('input', Number($event))"
			@change="$emit('change', Number($event))"
			@dblclick="onDblClick"
		></b-form-input>
	</b-form-group>
</template>

<script>
export default {
	props: {
		label: { type: String, required: true },
		value: { type: Number, required: true },
		min: { type: Number, default: 0 },
		max: { type: Number, default: 100 },
		step: { type: Number, default: 1 },
		resetValue: { type: Number, default: null },
	},
	methods: {
		onDblClick() {
			if (this.resetValue === null) return;
			this.$emit('input', this.resetValue);
			this.$emit('change', this.resetValue);
		},
	},
};
</script>

<style>
.slider-form-group legend,
.slider-form-group label,
.slider-form-group .col-form-label {
	margin-bottom: 0;
	padding-bottom: 0;
}
</style>
